function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        fill: none;\r\n      }\r\n\r\n      .cls-2 {\r\n        fill: url(#linear-gradient);\r\n      }\r\n\r\n      .cls-3 {\r\n        clip-path: url(#clippath);\r\n      }\r\n    "), /*#__PURE__*/React.createElement("clipPath", {
  id: "clippath"
}, /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M24,32.35h-16L0,18.5,8,4.64h16l8,13.86-8,13.86ZM9.42,29.89h13.16l6.58-11.39-6.58-11.39h-13.16l-6.58,11.39,6.58,11.39ZM20.68,10.17h-7.8l4.6,8.33-4.6,8.33h7.8l4.6-8.33-4.6-8.33Z"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient",
  x1: 0,
  y1: 19.84,
  x2: 32,
  y2: 19.84,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "aqua"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.36,
  stopColor: "#00a4c1"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.67,
  stopColor: "#006193"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.88,
  stopColor: "#003776"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.99,
  stopColor: "#00276c"
})));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  className: "cls-3"
}, /*#__PURE__*/React.createElement("rect", {
  className: "cls-2",
  width: 32,
  height: 39.68
}));

var SvgCordel = function SvgCordel(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    viewBox: "0 0 32 39.68",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCordel, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/cordel.b69e416a.svg";
export { ForwardRef as ReactComponent };